module.exports = __webpack_public_path__ + "img/michael.673eb875.png";